const initMoveTo = () => {
  const moveTo = new MoveTo({
    tolerance: 120,
    duration: 1200,
    easing: 'easeOutQuart',
  });

  const links = document.querySelectorAll('.main-nav__link, .contacts__menu-link, .scroll-items__btn:not([data-hidden-items-btn]), .mainscreen__icon-wrapper, [data-move-to]');

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', (evt) => {
      evt.preventDefault();

      const linkHref = links[i].getAttribute('href');
      const target = document.getElementById(linkHref.match(/#([^ ]*)/)[1]);

      if (target !== null) {
        moveTo.move(target);
      } else {
        window.location.replace(linkHref);
      }
    });
  }
};

export {initMoveTo};
